import { NgModule } from '@angular/core';
import { CompactVisitorInfoComponent } from './compact-visitor-info.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    FormsModule,
    SvgIconModule
  ],
  declarations: [
    CompactVisitorInfoComponent
  ],
  exports: [
    CompactVisitorInfoComponent
  ]
})
export class CompactVisitorInfoModule {}
